import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import Selectsearch from "react-select";
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import DatePicker from "react-datepicker";
import moment from 'moment';
import {
	FormGroup,
	Label,	
} from 'reactstrap';

import {
   allStudents,
   stdBDTenPoints,
   stdBDTenPutts,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ProgressLoader from 'Components/Widgets/ProgressLoader';

import PointSystem from './component/pointsystem';
import PuttSystem from './component/puttsystem';

class broadiedrillten extends Component {
   
   constructor(props) {
      
      super(props);
      let startDate = new Date();
      let befrstart=new Date(startDate.setMonth(startDate.getMonth() - 2));
      this.confirmationDialog = React.createRef();
         this.state = {
            student:'',
            startdate:befrstart,
            enddate:new Date(),
            viewdiv1:true,
            viewdiv2:false,
            viewdiv3:false,
            loader:false,  
            formValues: [{ puttdate:"", noputt:""}],
            sepmore:1,
            linedata:[],
            linemax:20, 
            puttformValues: [{ puttdate:"", noputt:""}],
            putsepmore:1,
            putlinedata:[],
            putlinemax:20, 
            totavgpoints:0,  
            totavgputts:0,      
         };  
   } 

   UNSAFE_componentWillMount() {
	   this.props.allStudents();
	} 

   selstudent(evt){
        var student=evt.value;
        var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        
        this.setState({ 
            loader:true,
            student: student,  
            viewdiv2:false,
        });

        this.props.stdBDTenPutts(student, stdate, eddate).then((data) => {   
            var resdata=data.data;
            var troptobj=[]; 
            var alldata=[]; 
            var highval=[];
            var st=0;
            if(resdata.length!=0){
               
                {resdata.map((teamval, idx) => (   
                     
                    troptobj.push({
                        puttdate:new Date(teamval.gpb_date),
                        noputt:teamval.gpb_points,
                    }),
                    alldata.push({
                        x:idx+1,
                        y:teamval.gpb_points,
                    }),
                    highval[idx]=teamval.gpb_points,
                    st=st+teamval.gpb_points
                    
                ))}
                var totavg=parseFloat((st/resdata.length).toFixed(2));
                const maxNumber = Math.max(...highval)+10;
                this.setState({
                    puttformValues:troptobj,
                    putsepmore:resdata.length,
                    putlinedata:[...alldata],
                    putlinemax:maxNumber,
                    totavgputts:totavg
                });
            }else{
                this.setState({
                    puttformValues: [{ puttdate:"", noputt:""}],
                    putsepmore:1,
                    putlinedata:[],
                    putlinemax:20,  
                });  
            }

        });
        
        this.props.stdBDTenPoints(student, stdate, eddate).then((data) => {   
            var resdata=data.data;
            var troptobj=[]; 
            var alldata=[]; 
            var highval=[];
            var st=0;
            if(resdata.length!=0){
               
                {resdata.map((teamval, idx) => (   
                     
                    troptobj.push({
                        puttdate:new Date(teamval.gpb_date),
                        noputt:teamval.gpb_points,
                    }),
                    alldata.push({
                        x:idx+1,
                        y:teamval.gpb_points,
                    }),
                    highval[idx]=teamval.gpb_points,
                    st=st+teamval.gpb_points
                    
                ))}
                var totavg=parseFloat((st/resdata.length).toFixed(2));
                const maxNumber = Math.max(...highval)+10;
                this.setState({
                    formValues:troptobj,
                    sepmore:resdata.length,
                    linedata:[...alldata],
                    linemax:maxNumber,
                    totavgpoints:totavg
                });
            }else{
                this.setState({
                    formValues: [{ puttdate:"", noputt:""}],
                    sepmore:1,
                    linedata:[],
                    linemax:20,  
                });  
            }

            this.setState({ 
                loader:false, 
                viewdiv2:true,
            });

        });
    }

    selectstart = (date) => {  
        this.setState({ startdate:date });           
    }

    selectend = (date) => {  
        this.setState({ enddate:date });           
    }

    handleSubmit(evt){
        evt.preventDefault();   
        var student=this.state.student;
        var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        
        this.setState({ 
            loader:true,
            viewdiv2:false,
        });

        this.props.stdBDTenPutts(student, stdate, eddate).then((data) => {   
            var resdata=data.data;
            var troptobj=[]; 
            var alldata=[]; 
            var highval=[];
            var st=0;
            if(resdata.length!=0){
               
                {resdata.map((teamval, idx) => (   
                     
                    troptobj.push({
                        puttdate:new Date(teamval.gpb_date),
                        noputt:teamval.gpb_points,
                    }),
                    alldata.push({
                        x:idx+1,
                        y:teamval.gpb_points,
                    }),
                    highval[idx]=teamval.gpb_points,
                    st=st+teamval.gpb_points
                    
                ))}
                var totavg=parseFloat((st/resdata.length).toFixed(2));
                
                const maxNumber = Math.max(...highval)+10;
                this.setState({
                    puttformValues:troptobj,
                    putsepmore:resdata.length,
                    putlinedata:[...alldata],
                    putlinemax:maxNumber,
                    totavgputts:totavg
                });
            }else{
                this.setState({
                    puttformValues: [{ puttdate:"", noputt:""}],
                    putsepmore:1,
                    putlinedata:[],
                    putlinemax:20,  
                });  
            }

        });
        
        this.props.stdBDTenPoints(student, stdate, eddate).then((data) => {   
            var resdata=data.data;
            var troptobj=[]; 
            var alldata=[]; 
            var highval=[];
            var st=0;
            
            if(resdata.length!=0){
               
                {resdata.map((teamval, idx) => (   
                     
                    troptobj.push({
                        puttdate:new Date(teamval.gpb_date),
                        noputt:teamval.gpb_points,
                    }),
                    alldata.push({
                        x:idx+1,
                        y:teamval.gpb_points,
                    }),
                    highval[idx]=teamval.gpb_points,
                    st=st+teamval.gpb_points
                    
                ))}
                var totavg=parseFloat((st/resdata.length).toFixed(2));
                const maxNumber = Math.max(...highval)+10;
                this.setState({
                    formValues:troptobj,
                    sepmore:resdata.length,
                    linedata:[...alldata],
                    linemax:maxNumber,
                    totavgpoints:totavg
                });
            }else{
                this.setState({
                    formValues: [{ puttdate:"", noputt:""}],
                    sepmore:1,
                    linedata:[],
                    linemax:20,  
                });  
            }

            this.setState({ 
                loader:false, 
                viewdiv2:true,
            });

        });
        
    }   

   

    render() {
      const { match, studentlists, loading } = this.props;

      const allstudent=studentlists.map((stdval) => {  
         return {
            label: stdval.student,  
            value: stdval.uudID
         }
      });

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>10FT Broadie Drill | {AppConfig.appTitle}</title>
                <meta name="description" content="Golf" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.tenbroadiedrill" />} match={match} />
             <div className="row" >
                        {this.state.viewdiv1 &&                             
                            <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                                <RctCollapsibleCard>                              
                                    <form autoComplete="off" id="addform" onSubmit={(e)=>this.handleSubmit(e)}>              
                                        <div className="row">      
                                            <div className="col-lg-4">
                                            <FormGroup>
                                                <Label for="Select">Student *</Label>
                                                <Selectsearch id="student" name="student" placeholder="Select Student *" options={allstudent} value={allstudent.find(obj => obj.value === this.state.student)} onChange={evt => this.selstudent(evt)} required/>
                                            </FormGroup>
                                            </div>                                              
                                            <div className="col-lg-3">
                                                <FormGroup >
                                                    <DatePicker className="form-control" id="startdate" placeholderText="Start Date"  name="startdate" required autoComplete="off" 
                                                            selected={this.state.startdate}
                                                            onChange={this.selectstart}
                                                            dateFormat='yyyy-MM-dd'
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown 
                                                        /> 
                                                </FormGroup>                                          
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup >
                                                    <DatePicker className="form-control" id="enddate" placeholderText="End Date"  name="enddate" required autoComplete="off" 
                                                            selected={this.state.enddate}
                                                            onChange={this.selectend}
                                                            dateFormat='yyyy-MM-dd'
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                        /> 
                                                </FormGroup>                                          
                                            </div>
                                            <div className="form-group">                       
                                                <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Filter"/>                                            
                                            </div>              
                                        </div>
                                    </form>  
                                </RctCollapsibleCard>                                                    
                            </div>
                        }
                </div>
               {this.state.viewdiv2 && 
                 <>
                  <PointSystem data={this.state}/>
                  <PuttSystem data={this.state}/>
                 </>
               }

                {this.state.loader &&
                    <div className="col-lg-12">
                        <ProgressLoader />
                    </div>
                }

                               
          </div>
       )
    }
 }

const mapStateToProps = ({ mostlyused }) => {
	const { studentlists, loading } = mostlyused;
	return { studentlists, loading };
}

export default connect(mapStateToProps, {
   allStudents,
   stdBDTenPoints,
   stdBDTenPutts,
})(broadiedrillten); 